module.exports = __webpack_public_path__ + "img/body.752d8e9b.png";